import Konva from "konva";
import { View2DZoomHandler } from "./View2DZoomHandler";
import type { ITopViewCanvas } from "$src/domain/designs/editor/ITopViewCanvas";
import type { EditorSettings } from "$src/domain/designs/settings/EditorSettings";
import type { ISettingConfigurable } from "$src/domain/designs/settings/ISettingsConfigurable";
import type { IVector2 } from "$src/domain/designs/core/IVector2";
import { SelectionBox } from "./SelectionBox";
import { LineDrawer } from "./LineDrawer";

export class KonvaTopViewCanvas
  implements ITopViewCanvas, ISettingConfigurable
{
  private editorSetting: EditorSettings;

  private stage: Konva.Stage;
  private gridLayer: Konva.Layer;
  private zoomHandler: View2DZoomHandler;
  private selectionBox: SelectionBox;
  //private lineDrawer: LineDrawer;

  private isDraggingStage: boolean = false;
  private startPos = { x: 0, y: 0 };

  constructor(container: HTMLDivElement, editorSetting: EditorSettings) {
    this.editorSetting = editorSetting;

    this.stage = new Konva.Stage({
      container: container,
      width: container.offsetWidth,
      height: container.offsetHeight,
      scaleX: 1,
    });

    this.gridLayer = new Konva.Layer();
    this.stage.add(this.gridLayer);

    this.zoomHandler = new View2DZoomHandler(this.stage, this.editorSetting);
    this.selectionBox = new SelectionBox(this.stage, this.gridLayer);
    //this.lineDrawer = new LineDrawer(this.stage, this.gridLayer);
    
    this.initEvents();

    var rect1 = new Konva.Rect({
      x: 50,
      y: 50,
      width: 200,
      height: 100,
      fill: 'lightblue',
      stroke: 'black',
      strokeWidth: 2,
      opacity: 0.7 // Opacité réglée à 70%
  });
  
  // Création du deuxième rectangle
  var rect2 = new Konva.Rect({
      x: 100,
      y: 100,
      width: 200,
      height: 100,
      fill: 'lightgreen',
      stroke: 'black',
      strokeWidth: 2,
      opacity: 0.7 // Opacité réglée à 70%
  });

  this.gridLayer.add(rect1);
  this.gridLayer.add(rect2);

  // Ajout du calque à la scène
  this.stage.add(this.gridLayer);

  }

  createLine(pointA: IVector2, pointB: IVector2): void {
    let line = new Konva.Line({
      points: [pointA.x, pointA.y, pointB.x, pointB.y],
      stroke: "black",
      strokeWidth: 0.6,
      strokeScaleEnabled: false,
      lineCap: "round",
      lineJoin: "round",
      draggable: true,
    });
    line.points();

    console.log("created line : " + line.id());

    var group = new Konva.Group();
    group.draggable(true);
    group.add(line);

    var arc = new Konva.Arc({
      x: 50,
      y: 50,
      innerRadius: 0,
      outerRadius: 70,
      angle: 60,
      fill: "rgba(255,0,0,0.6)",
      stroke: "black",
      strokeWidth: 0.6,
      strokeScaleEnabled: false,
    });

    group.add(arc);

    var text = new Konva.Text({
      text: "3523 mm",
      fill: "black",
      x: 10,
      y: 20,
      fontSize: 12,
    });

    group.add(text);

    this.gridLayer.add(group);
  }

  private initEvents() {
    // do not show context menu on right click
    this.stage.on("contextmenu", (e) => {
      e.evt.preventDefault();
    });

    this.stage.on("mousemove", (e) => {
      if (this.isDraggingStage) {
        const dx = e.evt.movementX;
        const dy = e.evt.movementY;
        this.stage.position({
          x: this.startPos.x + dx,
          y: this.startPos.y + dy,
        });
        this.startPos = { x: this.stage.x(), y: this.stage.y() };
      }
    });

    this.stage.on("mousedown", (e) => {
      if (e.evt.button === 2) {
        // Bouton droit
        this.isDraggingStage = true;
        this.startPos = { x: this.stage.x(), y: this.stage.y() };
        this.stage.container().style.cursor = "grabbing";
      }
    });

    this.stage.on("mouseup", (e) => {
      if (e.evt.button === 2) {
        // Bouton droit
        this.isDraggingStage = false;
        this.stage.container().style.cursor = "default";
      }
    });
  }

  public resizeCanvas(width: number, height: number): void {
    console.log('resize : ', width, height)
    this.stage.width(width);
    this.stage.height(height);
    this.stage.batchDraw();
  }

  public setEditorSetting(editorSetting: EditorSettings) {
    this.editorSetting = editorSetting;
    this.setEditorSetting(editorSetting);
  }
}
